import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-loaders-page-ui',
    templateUrl: './bb-loaders-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbLoadersPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
